import { defineMessages } from 'react-intl';

export const lwaDeprecationMessages = defineMessages({
  lwaDeprecationLearnMoreButton: {
    id: 'lwaDeprecationLearnMoreButton.label',
    defaultMessage: 'Learn more',
    description: 'Learn More Button in the Banner',
  },
  builderIdProviderDescription: {
    id: 'builderIdProviderDescription.text',
    defaultMessage: `Use your <supportLink>AWS Builder ID</supportLink> or create one.`,
    description: 'Builder ID provider description',
  },
  builderIdProviderNote: {
    id: 'builderIdProviderNote.text',
    defaultMessage: `<b>Note:</b> If you previously used <b>Login with Amazon</b>, use this. You’ll be prompted to link your AWS Builder ID to your existing profile if they share the same email.`,
    description: 'Builder ID description note',
  },
});
